import * as React from "react"
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardFooter
} from "../components/card"
import { Button } from "../components/button"
import { cn } from "../lib/utils"

export interface UserCardProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string
  description?: string
  avatar?: string
  onAction?: () => void
  actionLabel?: string
}

const UserCard = React.forwardRef<HTMLDivElement, UserCardProps>(
  (
    {
      className,
      name,
      description,
      avatar,
      onAction,
      actionLabel = "View Profile",
      ...props
    },
    ref
  ) => {
    return (
      <Card ref={ref} className={cn("w-[350px]", className)} {...props}>
        <CardHeader>
          <div className="flex items-center gap-4">
            {avatar && (
              <div className="h-12 w-12 rounded-full overflow-hidden bg-muted">
                <img
                  src={avatar}
                  alt={name}
                  className="h-full w-full object-cover"
                />
              </div>
            )}
            {!avatar && (
              <div className="h-12 w-12 rounded-full bg-muted flex items-center justify-center">
                <span className="text-lg font-semibold">
                  {name.charAt(0).toUpperCase()}
                </span>
              </div>
            )}
            <div className="flex-1">
              <CardTitle>{name}</CardTitle>
              {description && <CardDescription>{description}</CardDescription>}
            </div>
          </div>
        </CardHeader>
        {onAction && (
          <CardFooter>
            <Button className="w-full" onClick={onAction}>
              {actionLabel}
            </Button>
          </CardFooter>
        )}
      </Card>
    )
  }
)
UserCard.displayName = "UserCard"

export { UserCard }
